/**
 * Ce que dit `<StudentLiveQuizPage>` : l'offre de Sam, le jeu (les mots du défi éclair), le résultat.
 * À part de la page, sans rien de React Native : les phrases se testent seules.
 */
import { CHALLENGE_GAME_TEXTS } from "../../organisms/CorrectionChallenge/challengeGame"

export const LIVE_QUIZ_TEXTS = {
    ...CHALLENGE_GAME_TEXTS,
    title: "Quiz de fin de séance",
    preparing: "Sam prépare ton quiz…",
    offer: (minutes: number) => `${minutes} minute${minutes > 1 ? "s" : ""} pour ne rien oublier de ta séance ?`,
    size: (total: number) => `${total} questions`,
    missed: (missed: number) => `dont ${missed} que tu avais ratée${missed > 1 ? "s" : ""}`,
    reward: "si tu vas au bout",
    start: "Je commence",
    exit: { report: "Voir mon compte rendu", home: "Retour à l'accueil" },
    leave: "Partir du quiz",
    verdict: (right: number, total: number) =>
        right === total ? "Parfait, tout est juste !" : right * 2 >= total ? "Bien joué !" : "Tu as fait le plus dur.",
    missedBack: (missed: number) =>
        missed > 1 ? `Les ${missed} questions ratées reviendront.` : "La question ratée reviendra.",
    correction: "Ta correction",
    continue: "Continuer",
}
